/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarsStrokeH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6.908 17C4.198 17 2 14.761 2 12s2.197-5 4.908-5c2.374 0 4.354 1.718 4.809 4h1.319l.001-3H15v3h3.242l-2.25-2.293 1.388-1.414L22 12l-4.62 4.707-1.388-1.414L18.24 13H15v3h-1.963l-.001-3-1.32.001C11.263 15.283 9.282 17 6.909 17zm0-8c-1.626 0-2.945 1.343-2.945 3s1.319 3 2.945 3 2.944-1.343 2.944-3-1.318-3-2.944-3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMarsStrokeH as MarsStrokeH };
